import { UseMutationResult } from '@tanstack/react-query';

import { getRespondedYearToDateReportCsv, useBaseReportCsv } from 'api';

export const useRespondedYearToDateReportCsv = (): UseMutationResult<Blob> =>
  useBaseReportCsv(getRespondedYearToDateReportCsv);
